// extracted by mini-css-extract-plugin
module.exports = {"Button":"AccountSwitcher_Button_2WckG","Select":"AccountSwitcher_Select_3BY_B"};